import React, { Fragment, useEffect, useState } from 'react'
import TopHeader from '../../../../Components/TopHeader/TopHeader'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Card, CardContent, Dialog, Grid, IconButton, Typography } from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { GET_BY_ID_USER_INTERPRETER_ACTION, GET_MILISTONE_USER_INTERPRETER_ACTION, GET_PLAN_USER_INTERPRETER_ACTION, USER_RATE_AND_REVIEW_ACTION } from '../../../../Redux/Slices/UserSlice/User.action';
import CustomInterpreterTabPanel from '../../../../Components/CustomInterpreterTabPanel/CustomInterpreterTabPanel';
import CustomInterpreterTabs from '../../../../Components/CustomInterpreterTabPanel/CustomInterpreterTabs';
import InterpreterLegalDocumentTranslator from './InterpreterLegalDocumentTranslator/InterpreterLegalDocumentTranslator';
import { GET_BY_ID_JOB_INTERPRETER_ACTION, GET_UNAVAILAVILITY_ACTION } from '../../../../Redux/Slices/InterpreterSlice/Interpreter.action';
import IntrepreterBasicDetails from './IntrepreterBasicDetails/IntrepreterBasicDetails';
import InderpreterReviewProfile from './IntrepreterBasicDetails/InderpreterReviewProfile/InderpreterReviewProfile';
import Constant from '../../../../Utils/Constant';
import NoDataImg from '../../../../Components/NoDataFound/NoDataFound';
import IntrepreterReview from './InterpreterReview/IntrepreterReview';
import IntrepreterAvailability from './IntrepreterAvailability/IntrepreterAvailability';
import { GET_ANALYTICS_ACTION } from '../../../../Redux/Slices/AnalyticsSlice/AnalyticsSlice.action';
import IntpreterMilestoneAchievement from './IntpreterMilestoneAchievement/IntpreterMilestoneAchievement';
import CoinTransaction from '../UserViewDetails/CoinTransaction/CoinTransaction';
import AxiosInstance from '../../../../Config/AxiosInstance';
import APILIST from '../../../../Config/ApiList';
import AddCoinAdjustmentModel from '../UserViewDetails/AddCoinAdjustmentModel/AddCoinAdjustmentModel';
import ReferralsDetails from './ReferralsDetails/ReferralsDetails';
import CustomSubmitButton from '../../../../Components/CustomSubmitButton/CustomSubmitButton';
import CustomDatePicker from '../../../../Components/CustomDatePicker/CustomDatePicker';
import CustomTimePicker from '../../../../Components/CustomTimePicker/CustomTimePicker';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import moment from 'moment';
import dayjs from 'dayjs';
import CustomDatePicker1 from '../../../../Components/CustomDatePicker/CustomDatePicker1';
const InterpreterDetails = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading1, setIsLoading1] = useState(false);
    const [interpreterDetails, setInterpreterDetails] = useState({});
    const [interpreterActiveTabs, setInterpreterActiveTabs] = useState(0);
    const [interpreterLegalDocumentT, setInterpreterLegalDocumentT] = useState([]);
    const [interpreterRateAndReview, setInterpreterRateAndReview] = useState([]);
    const [interpreterUnAvailability, setInterpreterUnAvailability] = useState([]);
    const [analyticsList, setAnalyticsList] = useState([]);
    const [interpreterMilestone, setInterpreterMilestone] = useState({});
    const [interpreterPlan, setInterpreterPlan] = useState({});
    const [coinTransactionList, setCoinTransactionList] = useState([]);
    const [refferalList, setReferralList] = useState([]);
    const [showAddCoinModal, setShowAddCoinModal] = useState(false);
    const [userID, setUserID] = useState(null);
    const [assignPlanModel, setAssignPlanModel] = useState(false);
    const interpreterTabs = [
        { label: 'Session Details', content: 'Session Details' },
        { label: 'Unavailability ', content: 'Unavailability' },
        { label: 'Rate & Review', content: 'Rate & Review' },
        { label: 'Milestone & Premium', content: 'Milestone & Premium' },
        { label: 'Approved Details', content: 'Approved Details' },
        { label: 'Coin Transaction', content: 'Coin Transaction' },
        { label: 'Referrals', content: 'Referrals' }
    ];
    useEffect(() => {
        if (location?.state?.id) {
            const userId = location?.state?.id;
            setUserID(userId)
            getInterpreterDetails(userId);
            getAnalytics(userId);
            getInterpreterLegalDocumentsTranslator(userId)
        }
    }, [location?.state?.id]);
    useEffect(() => {
        if (location?.state?.id) {
            const userId = location?.state?.id;
            if (interpreterActiveTabs == 0) {
                getInterpreterLegalDocumentsTranslator(userId);
            } else if (interpreterActiveTabs === 1) {
                getUnAvailability(userId);
            } else if (interpreterActiveTabs === 2) {
                getUserRateAndReview(userId);
            } else if (interpreterActiveTabs === 3) {
                getInterpreterMilistone(userId);
                getInterpreterPlan(userId);
            } else if (interpreterActiveTabs === 5) {
                getUserCoinTransaction(userId);
            } else if (interpreterActiveTabs === 6) {
                getReferrals(userId);
            }
        }
    }, [location?.state?.id, interpreterActiveTabs]);

    const getInterpreterDetails = async (id) => {
        try {
            setIsLoading(true);
            const result = await dispatch(GET_BY_ID_USER_INTERPRETER_ACTION(id));
            if (result && result?.payload?.s === 1) {
                setInterpreterDetails(result?.payload?.r);
            } else {
                console.log("No user found");
                setInterpreterDetails({});
            }
        } catch (error) {
            console.error("Error fetching user details", error);
        } finally {
            setIsLoading(false);
        }
    };
    const getUserRateAndReview = async (id) => {
        try {
            setIsLoading1(true);
            const result = await dispatch(USER_RATE_AND_REVIEW_ACTION(id));
            if (result && result?.payload?.s === 1) {
                setInterpreterRateAndReview(result?.payload?.r);
            } else {
                setInterpreterRateAndReview([]);
            }
        } catch (error) {
            console.error("Error fetching review", error);
        } finally {
            setIsLoading1(false);
        }
    };
    const getUnAvailability = async (id) => {
        try {
            setIsLoading1(true);
            const result = await dispatch(GET_UNAVAILAVILITY_ACTION(id));
            if (result && result?.payload?.s === 1) {
                setInterpreterUnAvailability(result?.payload?.r);
            } else {
                setInterpreterUnAvailability([]);
            }
        } catch (error) {
            console.error("Error fetching UnAvailability", error);
        } finally {
            setIsLoading1(false);
        }
    };
    const getAnalytics = async (id) => {
        try {
            setIsLoading1(true);
            const result = await dispatch(GET_ANALYTICS_ACTION(id));
            if (result && result?.payload?.s === 1) {
                setAnalyticsList(result?.payload?.r);
            } else {
                setAnalyticsList([]);
            }
        } catch (error) {
            console.error("Error fetching analytics", error);
        } finally {
            setIsLoading1(false);
        }
    };
    const getInterpreterMilistone = async (id) => {
        try {
            setIsLoading1(true);
            const result = await dispatch(GET_MILISTONE_USER_INTERPRETER_ACTION(id));
            if (result && result?.payload?.s === 1) {
                setInterpreterMilestone(result?.payload?.r);
            } else {
                setInterpreterMilestone({});
            }
        } catch (error) {
            console.error("Error fetching analytics", error);
        } finally {
            setIsLoading1(false);
        }
    };
    const getInterpreterLegalDocumentsTranslator = async (id) => {
        try {
            setIsLoading1(true);
            const result = await dispatch(GET_BY_ID_JOB_INTERPRETER_ACTION(id));
            console.log('resultcalling', result);

            if (result && result?.payload?.s === 1) {
                const rowData = result?.payload?.r;
                if (rowData) {
                    setInterpreterLegalDocumentT(rowData);
                } else {
                    console.log("Interpreter legal document not found.");
                    setInterpreterLegalDocumentT([]);
                }
            } else {
                console.log("No valid response from the server.");
                setInterpreterLegalDocumentT([]);
            }
        } catch (error) {
            console.error("Error fetching interpreter legal documents", error);
            alert("An error occurred while fetching the interpreter's legal documents.");
        } finally {
            setIsLoading1(false);
        }
    };
    const getInterpreterPlan = async (id) => {
        try {
            setIsLoading1(true);
            const result = await dispatch(GET_PLAN_USER_INTERPRETER_ACTION(id));
            console.log('resultcalling', result);

            if (result && result?.payload?.s === 1) {
                const rowData = result?.payload?.r;
                if (rowData) {
                    setInterpreterPlan(rowData);
                } else {
                    console.log("Plan not found.");
                    setInterpreterPlan({});
                }
            } else {
                console.log("No valid response from the server.");
                setInterpreterPlan({});
            }
        } catch (error) {
            console.error("Error fetching plan", error);
            alert("An error occurred while fetching the interpreter's plan.");
        } finally {
            setIsLoading1(false);
        }
    }
    const getUserCoinTransaction = async (id) => {
        try {
            setIsLoading(true);
            const result = await AxiosInstance.get(APILIST.GET_ALL_COIN_ADJUSMENT_API, {
                params: {
                    user_id: id
                }
            });
            if (result && result?.data?.s === 1) {
                setCoinTransactionList(result?.data?.r);
            } else {
                console.log("No review found");
                setCoinTransactionList([]);
            }
        } catch (error) {
            console.error("Error fetching coin transaction", error);
        } finally {
            setIsLoading(false);
        }
    };
    const getReferrals = async (id) => {
        try {
            setIsLoading(true);
            const result = await AxiosInstance.get(APILIST.GET_REFERRALS_API, {
                params: {
                    user_id: id
                }
            });

            if (result && result?.data?.s === 1) {
                setReferralList(result?.data?.r);
            } else {
                console.log("No referral found");
                setReferralList([]);
            }
        } catch (error) {
            console.error("Error fetching referral", error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleOnChangeActiveTabsInterpreter = (event, newValue) => {
        setInterpreterActiveTabs(newValue);
    };
    const handleSubmitAcceptReject = () => {
        getInterpreterDetails(location?.state?.id);
    }
    const handleAddCoinModalOpen = () => {
        setShowAddCoinModal(true)
    }
    const handleSubmitAddCoin = () => {
        setShowAddCoinModal(false);
        getInterpreterDetails(location?.state?.id);
        getUserCoinTransaction(location?.state?.id);
    }
    const formikAssignPlan = useFormik({
        initialValues: {
            start_date: null,
            end_date: null,
        },
        validationSchema: Yup.object().shape({
            start_date: Yup.date()
                .required("Start date is required"),
            end_date: Yup.date()
                .required("End date is required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            setIsLoading(true);
            if (isLoading) return;

            try {
                const start = moment.utc(values.start_date?.$d).startOf('day').format("YYYY-MM-DD HH:mm:ss");
                const end = moment.utc(values.end_date?.$d).startOf('day').format("YYYY-MM-DD HH:mm:ss");


                const formData = new FormData();
                formData.append("user_id", interpreterDetails?.id);
                formData.append("start_time", start);
                formData.append("end_time", end);
                formData.append("type", 2);
                const response = await AxiosInstance.post(APILIST.ADMIN_ASSIGN_INTERPRETER_PLAN, formData);

                if (response?.data?.s) {
                    toast.success("Plan assigned successfully");
                    setAssignPlanModel(false);
                    resetForm();
                    getInterpreterDetails(location?.state?.id);
                } else {
                    toast.error(response?.data?.m || "Failed to assign plan");
                }
            } catch (error) {
                toast.error(error?.response?.data?.m || "An error occurred");
                console.error('Error:', error);
            } finally {
                setIsLoading(false);
            }
        },
    })
    return (
        <Fragment>
            <TopHeader
                title={"Interpreter Details"}
                onClick={() => navigate(-1)}
                type="button"
                showButton={false}
            />
            <Box
                sx={{
                    padding: "60px 15px 0px 15px",
                    maxWidth: { xs: "100%" },
                    margin: "0 auto",
                    width: "100%",
                }}
            >
                <Box sx={{
                    display: 'flex',
                    gap: '20px',
                    flexDirection: { xs: 'column', md: 'row' },
                }}>
                    <Box sx={{
                        maxWidth: { xs: "100%", md: '300px' },
                        width: '100%'
                    }}>
                        <Card
                            sx={{
                                background: "rgba(230, 245, 247, 1)",
                                position: "relative",
                                width: '100%'
                            }}
                        >

                            <CardContent>
                                {isLoading ? <Skeleton height={116} width={116} borderRadius={50} /> :
                                    <Box
                                        sx={{
                                            width: '116px',
                                            margin: '0 auto 30px auto',
                                            position: 'relative',
                                        }}
                                    >
                                        {interpreterDetails?.profile_img ? <img
                                            src={`${Constant.BASE_URL}${interpreterDetails?.profile_img}`}
                                            alt="interpreter_Profile"
                                            style={{
                                                width: "116px",
                                                height: "116px",
                                                objectFit: "cover",
                                                borderRadius: "50%",
                                                objectPosition: "top",
                                            }}
                                        /> : <AccountCircleIcon sx={{ fontSize: "116px" }} />}
                                        {
                                            interpreterDetails?.premium_plan
                                                ? (
                                                    interpreterDetails?.premium_plan?.type
                                                        ? (() => {
                                                            const type = interpreterDetails?.premium_plan?.type;

                                                            let label = "Premium";
                                                            let background = "#F9B600";
                                                            let color = "#000";

                                                            if (type === null || type === 0) {
                                                                label = "Free";
                                                                background = "rgba(0,151,178,0.1)";
                                                                color = "rgba(0,151,178,1)";
                                                            } else if (type === 2) {
                                                                label = "Plan assigned by admin";
                                                                background = "rgba(255,153,0,0.1)";
                                                                color = "#FF9900";
                                                            }

                                                            return (
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: "14px",
                                                                        fontWeight: "500",
                                                                        color,
                                                                        textAlign: "center",
                                                                        width: "100%",
                                                                        fontFamily: "Outfit",
                                                                        background,
                                                                        borderRadius: "10px",
                                                                        padding: "5px 5px",
                                                                        position: "absolute",
                                                                        bottom: "-41px",
                                                                    }}
                                                                >
                                                                    {label}
                                                                </Typography>
                                                            );
                                                        })()
                                                        : (
                                                            <Button
                                                                type="button"
                                                                sx={{
                                                                    backgroundColor: "#0097B2",
                                                                    color: "#fff",
                                                                    fontFamily: "Outfit",
                                                                    fontSize: "14px",
                                                                    fontWeight: "500",
                                                                    padding: "8px 16px",
                                                                    borderRadius: "8px",
                                                                    textTransform: "capitalize",
                                                                    mt: "auto",
                                                                    width: "fit-content",
                                                                    "&:hover": {
                                                                        backgroundColor: "#007a91",
                                                                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                                                    },
                                                                }}
                                                                onClick={() => setAssignPlanModel(true)}
                                                            >
                                                                Assign Plan
                                                            </Button>
                                                        )
                                                )
                                                : <Button
                                                    type="button"
                                                    sx={{
                                                        backgroundColor: "#0097B2",
                                                        color: "#fff",
                                                        fontFamily: "Outfit",
                                                        fontSize: "14px",
                                                        fontWeight: "500",
                                                        padding: "8px 16px",
                                                        borderRadius: "8px",
                                                        textTransform: "capitalize",
                                                        mt: "auto",
                                                        width: "fit-content",
                                                        "&:hover": {
                                                            backgroundColor: "#007a91",
                                                            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                                        },
                                                    }}
                                                    onClick={() => setAssignPlanModel(true)}
                                                >
                                                    Assign Plan
                                                </Button>
                                        }
                                    </Box>}
                                <Box sx={{
                                    height: "calc(100vh - 260px)",
                                    overflowY: 'auto',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%',
                                    padding: '20px 0px'
                                }}>
                                    <Box sx={{ width: "100%" }}>
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                textAlign: "left",
                                                width: "100%",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            Full Name
                                        </Typography>
                                        {isLoading ? <Skeleton height={20} /> : <Typography
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "rgba(8, 85, 127, 1)",
                                                textAlign: "left",
                                                width: "100%",
                                                paddingTop: "4px",
                                                textTransform: "capitalize",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            {interpreterDetails?.full_name
                                                ? interpreterDetails?.full_name
                                                : "N/A"}
                                        </Typography>}
                                    </Box>
                                    <Box sx={{ width: '100%' }}>
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                textAlign: "left",
                                                width: "100%",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            Email
                                        </Typography>
                                        {isLoading ? <Skeleton height={20} /> : <Typography
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "rgba(8, 85, 127, 1)",
                                                textAlign: "left",
                                                width: "100%",
                                                paddingTop: "4px",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            {interpreterDetails?.email
                                                ? interpreterDetails?.email
                                                : "N/A"}
                                        </Typography>}
                                    </Box>
                                    <Box sx={{
                                        width: '100%'
                                    }}>
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                textAlign: "left",
                                                width: "100%",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            Mobile Number
                                        </Typography>
                                        {isLoading ? <Skeleton height={20} /> : <Typography
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "rgba(8, 85, 127, 1)",
                                                textAlign: "left",
                                                width: "100%",
                                                paddingTop: "4px",
                                                textTransform: "capitalize",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            {interpreterDetails?.phno
                                                ? `${interpreterDetails?.phno_cc} ${interpreterDetails?.phno}`
                                                : "N/A"}
                                        </Typography>}
                                    </Box>
                                    <Box sx={{ width: '100%' }}>
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                textAlign: "left",
                                                width: "100%",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            Address
                                        </Typography>
                                        {isLoading ? <Skeleton height={20} /> : <Typography
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "rgba(8, 85, 127, 1)",
                                                textAlign: "left",
                                                width: "100%",
                                                paddingTop: "4px",
                                                textTransform: "capitalize",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            {interpreterDetails?.address
                                                ? interpreterDetails?.address
                                                : "N/A"}
                                        </Typography>}
                                    </Box>
                                    <Box sx={{
                                        width: '100%'
                                    }}>
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                textAlign: "left",
                                                width: "100%",
                                                fontFamily: "Outfit",
                                                paddingTop: '10px'
                                            }}
                                        >
                                            Pin Code
                                        </Typography>
                                        {isLoading ? <Skeleton height={20} /> : <Typography
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "rgba(8, 85, 127, 1)",
                                                textAlign: "left",
                                                width: "100%",
                                                paddingTop: "4px",
                                                textTransform: "capitalize",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            {interpreterDetails?.zip_code
                                                ? interpreterDetails?.zip_code
                                                : "N/A"}
                                        </Typography>}
                                    </Box>
                                    <Box sx={{ width: '100%' }}>
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                textAlign: "left",
                                                width: "100%",
                                                fontFamily: "Outfit",
                                                paddingTop: '10px'
                                            }}
                                        >
                                            Service Radius
                                        </Typography>
                                        {isLoading ? <Skeleton height={20} /> : <Typography
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "rgba(8, 85, 127, 1)",
                                                textAlign: "left",
                                                width: "100%",
                                                paddingTop: "4px",
                                                textTransform: "capitalize",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            {`${interpreterDetails?.service_radius} miles` || 'N/A'}
                                        </Typography>}
                                    </Box>
                                    <Box sx={{ width: '100%' }}>
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                textAlign: "left",
                                                width: "100%",
                                                fontFamily: "Outfit",
                                                paddingTop: '10px'
                                            }}
                                        >
                                            Service Type
                                        </Typography>
                                        {isLoading ? <Skeleton height={20} /> : <Typography
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "rgba(8, 85, 127, 1)",
                                                textAlign: "left",
                                                width: "100%",
                                                paddingTop: "4px",
                                                textTransform: "capitalize",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            {interpreterDetails?.service_type ? interpreterDetails?.service_type === 1
                                                ? "Onsite"
                                                : interpreterDetails?.service_type === 2
                                                    ? "Virtual"
                                                    : "Both" : "N/A"}

                                        </Typography>}
                                    </Box>
                                    <Box sx={{
                                        width: '100%'
                                    }}>
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                textAlign: "left",
                                                width: "100%",
                                                fontFamily: "Outfit",
                                                paddingTop: '10px'
                                            }}
                                        >
                                            Assignment Type:
                                        </Typography>
                                        {isLoading ? <Skeleton height={20} /> : <Typography
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "rgba(8, 85, 127, 1)",
                                                textAlign: "left",
                                                width: "100%",
                                                paddingTop: "4px",
                                                textTransform: "capitalize",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            {interpreterDetails?.assignment || "N/A"}
                                        </Typography>}
                                    </Box>
                                    <Box sx={{ width: '100%' }}>
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                textAlign: "left",
                                                width: "100%",
                                                fontFamily: "Outfit",
                                                paddingTop: '10px'
                                            }}
                                        >
                                            Fee Range
                                        </Typography>
                                        {isLoading ? <Skeleton height={20} /> : <Typography
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "rgba(8, 85, 127, 1)",
                                                textAlign: "left",
                                                width: "100%",
                                                paddingTop: "4px",
                                                textTransform: "capitalize",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            {`${interpreterDetails?.fee_range_id == 1 ? "$25 to $50" : interpreterDetails?.fee_range_id == 2 ? "$50 to $75" : interpreterDetails?.fee_range_id == 3 ? "$75 to $100" : "100"}` || `$0`}
                                        </Typography>}
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>
                    <Box sx={{
                        width: 'calc(100%)',

                    }}>
                        {interpreterDetails?.interpreter_verified === 0
                            ? <InderpreterReviewProfile
                                interpreterDetails={interpreterDetails}
                                isLoading={isLoading}
                                handleSubmitAcceptReject={handleSubmitAcceptReject}
                                setIsLoading={setIsLoading}
                            />
                            : <Box sx={{
                                height: "calc(100vh - 70px)",
                                overflowY: 'auto',

                            }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12} md={4} lg={4} xl={2}>
                                        <Box sx={{
                                            background: "rgba(148, 148, 148, 0.1)",
                                            padding: '25px 20px',
                                            borderRadius: '15px',
                                        }}>
                                            <Typography sx={{
                                                color: 'rgba(8, 85, 127, 1)',
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                fontFamily: 'Outfit',
                                                textAlign: 'left'
                                            }}>{isLoading ? <Skeleton height={20} width={50} /> : analyticsList?.total_session || "N/A"}</Typography>
                                            <Typography sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                fontFamily: 'Outfit',
                                                textAlign: 'left'
                                            }}>Total Session</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} xl={2}>
                                        <Box sx={{
                                            background: "rgba(148, 148, 148, 0.1)",
                                            padding: '25px 20px',
                                            borderRadius: '15px',
                                        }}>
                                            <Typography sx={{
                                                color: 'rgba(8, 85, 127, 1)',
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                fontFamily: 'Outfit',
                                                textAlign: 'left'
                                            }}>{isLoading ? <Skeleton height={20} width={50} /> : analyticsList?.incomplete_session || "N/A"}</Typography>
                                            <Typography sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                fontFamily: 'Outfit',
                                                textAlign: 'left'
                                            }}>Incomplete Session</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} xl={2}>
                                        <Box sx={{
                                            background: "rgba(148, 148, 148, 0.1)",
                                            padding: '25px 20px',
                                            borderRadius: '15px',
                                        }}>
                                            <Typography sx={{
                                                color: 'rgba(8, 85, 127, 1)',
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                fontFamily: 'Outfit',
                                                textAlign: 'left'
                                            }}>{isLoading ? <Skeleton height={20} width={50} /> : analyticsList?.total_earning?.toFixed(2) || "N/A"}</Typography>
                                            <Typography sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                fontFamily: 'Outfit',
                                                textAlign: 'left'
                                            }}>Total Earnings</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} xl={2}>
                                        <Box sx={{
                                            background: "rgba(148, 148, 148, 0.1)",
                                            padding: '25px 20px',
                                            borderRadius: '15px',
                                        }}>
                                            <Typography sx={{
                                                color: 'rgba(8, 85, 127, 1)',
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                fontFamily: 'Outfit',
                                                textAlign: 'left'
                                            }}>{isLoading ? <Skeleton height={20} width={50} /> : analyticsList?.total_work_hours || "N/A"}</Typography>
                                            <Typography sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                fontFamily: 'Outfit',
                                                textAlign: 'left'
                                            }}>Total Hours Worked</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} xl={2}>
                                        <Box sx={{
                                            background: "rgba(148, 148, 148, 0.1)",
                                            padding: '25px 20px',
                                            borderRadius: '15px',
                                        }}>
                                            <Typography sx={{
                                                color: 'rgba(8, 85, 127, 1)',
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                fontFamily: 'Outfit',
                                                textAlign: 'left'
                                            }}>{isLoading ? <Skeleton height={20} width={50} /> : analyticsList?.rating || "N/A"}</Typography>
                                            <Typography sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                fontFamily: 'Outfit',
                                                textAlign: 'left'
                                            }}>Rating</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} xl={2}>
                                        {/* <Box sx={{
                                            background: "rgba(148, 148, 148, 0.1)",
                                            padding: '25px 20px',
                                            borderRadius: '15px',
                                        }}>
                                            <Typography sx={{
                                                color: 'rgba(8, 85, 127, 1)',
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                fontFamily: 'Outfit',
                                                textAlign: 'left'
                                            }}>{isLoading ? <Skeleton height={20} width={50} /> : interpreterDetails?.coin || "N/A"}</Typography>
                                            <Typography sx={{
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.7)",
                                                fontFamily: 'Outfit',
                                                textAlign: 'left'
                                            }}>Coin</Typography>
                                        </Box> */}
                                        <Box sx={{
                                            background: "rgba(148, 148, 148, 0.1)",
                                            padding: '24px',
                                            borderRadius: '16px',
                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
                                            border: '1px solid rgba(237, 242, 247, 1)',
                                            display: 'flex',
                                            gap: '12px',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            height: '100%',
                                            flexWrap: 'wrap'
                                        }}>
                                            <Box>
                                                <Typography sx={{
                                                    color: 'rgba(100, 116, 139, 1)',
                                                    fontSize: '16px',
                                                    fontWeight: '400',
                                                    fontFamily: 'Outfit',
                                                    mb: '4px'
                                                }}>Coin</Typography>

                                                {isLoading ? (
                                                    <Skeleton width={60} height={32} />
                                                ) : (
                                                    <Typography sx={{
                                                        color: 'rgba(8, 85, 127, 1)',
                                                        fontSize: '24px',
                                                        fontWeight: '600',
                                                        fontFamily: 'Outfit',
                                                        lineHeight: '1.2'
                                                    }}>
                                                        {interpreterDetails?.coin || "0"}
                                                    </Typography>
                                                )}
                                            </Box>

                                            <Button
                                                variant="contained"
                                                onClick={handleAddCoinModalOpen}
                                                sx={{
                                                    backgroundColor: '#0097B2',
                                                    color: '#fff',
                                                    fontFamily: 'Outfit',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    padding: '8px 16px',
                                                    borderRadius: '8px',
                                                    textTransform: 'capitalize',
                                                    mt: 'auto',
                                                    width: 'fit-content',
                                                    '&:hover': {
                                                        backgroundColor: '#007a91',
                                                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
                                                    }
                                                }}
                                            >
                                                Add Coin
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Box sx={{
                                    width: '100%',
                                    padding: '20px 0px 0px 0px'
                                }}>
                                    <CustomInterpreterTabs
                                        tabValue={interpreterActiveTabs}
                                        onChange={handleOnChangeActiveTabsInterpreter}
                                        interpreterTabs={interpreterTabs}
                                        interpreterDetails={interpreterDetails}
                                    />
                                    <CustomInterpreterTabPanel value={interpreterActiveTabs} index={0}>
                                        <InterpreterLegalDocumentTranslator
                                            interpreterLegalDocumentT={interpreterLegalDocumentT}
                                            isLoading={isLoading1}
                                        />
                                    </CustomInterpreterTabPanel>
                                    <CustomInterpreterTabPanel value={interpreterActiveTabs} index={1}>
                                        <IntrepreterAvailability
                                            interpreterUnAvailability={interpreterUnAvailability}
                                            isLoading={isLoading1}
                                        />
                                    </CustomInterpreterTabPanel>
                                    <CustomInterpreterTabPanel value={interpreterActiveTabs} index={2}>
                                        <IntrepreterReview
                                            interpreterRateAndReview={interpreterRateAndReview}
                                            isLoading={isLoading1}
                                        />
                                    </CustomInterpreterTabPanel>
                                    <CustomInterpreterTabPanel value={interpreterActiveTabs} index={3}>
                                        <IntpreterMilestoneAchievement
                                            interpreterMilestone={interpreterMilestone}
                                            isLoading={isLoading1}
                                            interpreterPlan={interpreterPlan}
                                        />

                                    </CustomInterpreterTabPanel>
                                    <CustomInterpreterTabPanel value={interpreterActiveTabs} index={4}>
                                        {interpreterDetails &&
                                            <IntrepreterBasicDetails
                                                interpreterDetails={interpreterDetails}
                                                setIsLoading={setIsLoading}
                                                isLoading={isLoading}
                                                // handleBasicDetailsNewLanguageApproveReject={handleBasicDetailsNewLanguageApproveReject}
                                                handleSubmitAcceptReject={handleSubmitAcceptReject}
                                            />}
                                    </CustomInterpreterTabPanel>
                                    <CustomInterpreterTabPanel value={interpreterActiveTabs} index={5}>
                                        <Box sx={{
                                            paddingTop: '24px'
                                        }}>
                                            <CoinTransaction
                                                coinTransactionList={coinTransactionList}
                                                isLoading={isLoading}
                                            />
                                        </Box>
                                    </CustomInterpreterTabPanel>
                                    <CustomInterpreterTabPanel value={interpreterActiveTabs} index={6}>
                                        <Box sx={{
                                            paddingTop: '24px'
                                        }}>
                                            <ReferralsDetails
                                                referralList={refferalList}
                                                isLoading={isLoading}
                                            />
                                        </Box>
                                    </CustomInterpreterTabPanel>
                                </Box>
                            </Box>}
                    </Box>
                </Box>
            </Box>
            <AddCoinAdjustmentModel
                open={showAddCoinModal}
                onClose={() => setShowAddCoinModal(false)}
                userId={userID}
                handleOnClose={() => setShowAddCoinModal(false)}
                handleSubmitAddCoin={handleSubmitAddCoin}
            />
            <Dialog
                open={assignPlanModel}
                onClose={() => {
                    setAssignPlanModel(false);
                    formikAssignPlan.resetForm();
                }}
                maxWidth="xs"
                fullWidth
                sx={{
                    "& .MuiPaper-root": {
                        borderRadius: "20px",
                        padding: '20px 30px',
                        height: "auto",
                        overflow: "scroll",
                        "::-webkit-scrollbar": { width: "0px", height: '0px' },
                        display: "flex",
                        flexDirection: "column",
                    },
                    "& .MuiDialogContent-root": {
                        overflowY: "initial",
                        flexGrow: 1,
                    },
                    "& .MuiBackdrop-root": {
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    }
                }}
            >
                <form onSubmit={(e) => {
                    e.preventDefault();
                    formikAssignPlan.handleSubmit();
                    return false;
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography sx={{ fontSize: '20px', fontWeight: '500', color: '#101010', fontFamily: "Plus Jakarta Sans, sans-serif", }}>
                            Assign Plan
                        </Typography>
                        <IconButton
                            sx={{
                                width: '30px',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: '#101010',
                                borderRadius: '8px',
                                "&:hover": { backgroundColor: '#101010', color: '#fff' }
                            }}
                            onClick={() => {
                                setAssignPlanModel(false);
                                formikAssignPlan.resetForm();
                            }}
                        >
                            <CloseIcon sx={{ color: '#fff', fontSize: '20px' }} />
                        </IconButton>
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingTop: '20px' }}>
                        <Box sx={{ width: '100%' }}>
                            <Typography sx={{ color: "black", fontWeight: "400", textAlign: "left", mb: "5px", fontFamily: "Plus Jakarta Sans, sans-serif", }}>
                                Start Date
                            </Typography>
                            <CustomDatePicker1
                                name={'start_date'}
                                minDate={dayjs()}
                                placeholder="Select Date"
                                value={formikAssignPlan.values.start_date}
                                onChange={(newValue) => {
                                    formikAssignPlan.setFieldValue('start_date', newValue);

                                }}
                                errors={formikAssignPlan.touched.start_date && formikAssignPlan.errors.start_date}

                                disabled={isLoading}
                            />
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <Typography sx={{ color: "black", fontWeight: "400", textAlign: "left", mb: "5px", fontFamily: "Plus Jakarta Sans, sans-serif", }}>
                                End Date
                            </Typography>
                            <CustomDatePicker1
                                name={'end_date'}
                                minDate={formikAssignPlan.values.start_date ? dayjs(formikAssignPlan.values.start_date) : dayjs()}
                                placeholder="Select Date"
                                value={formikAssignPlan.values.end_date}
                                onChange={(newValue) => formikAssignPlan.setFieldValue('end_date', newValue)}
                                errors={formikAssignPlan.touched.end_date && formikAssignPlan.errors.end_date}
                                disabled={isLoading}
                            />
                        </Box>
                    </Box>

                    <Box sx={{ paddingTop: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
                        <CustomSubmitButton
                            btnTitle="Cancel"
                            loading={isLoading}
                            type="button"
                            onSubmit={() => setAssignPlanModel(false)}
                            sx={{
                                background: "#F3F3F3",
                                color: "#101528",
                                "&:hover": {
                                    background: "#F3F3F3",
                                    color: "#101528",
                                },
                            }}
                        />
                        <CustomSubmitButton
                            btnTitle={"Assign Plan"}
                            loading={isLoading}
                            type="submit"
                            sx={{
                                fontFamily: "Plus Jakarta Sans, sans-serif",
                                fontSize: "16px",
                            }}
                        />
                    </Box>
                </form>
            </Dialog>
        </Fragment>
    )
}

export default InterpreterDetails